import { THEMATIC_PORTFOLIOS } from "@/config/kingbullish";
import { ThematicPortfolioCard } from "@/components/ThematicPortfolioCard";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/motion/Reveal";
import { usePortfolioCelebration } from "@/components/portfolio/usePortfolioCelebration";
import { PortfolioRainbow } from "@/components/portfolio/PortfolioRainbow";
import "@/styles/portfolio-lucky.css";

export const PortfoliosSection = () => {
  const lucky = usePortfolioCelebration();
  return (
  <section id="portfolios" className="section relative overflow-hidden !pt-4 lg:!pt-6 pf-lucky-section" data-testid="portfolios-section"
    data-lucky-phase={lucky.phase} data-lucky-count={lucky.count} data-lucky-pending={lucky.pending} data-lucky-motion={lucky.running ? "running" : "paused"}>
    <div className="planet -bottom-40 -right-24 h-[520px] w-[520px] opacity-80" />
    <div className="container-x relative">
      <SectionHeading
        title="KINGBULLISH"
        accent="THEMATIC PORTFOLIOS"
        testId="portfolios-heading"
        right={
          <p className="font-display text-base font-semibold tracking-wide text-white/80 md:text-lg" data-testid="portfolios-subtitle">
            INVEST IN THE SECTORS THAT BUILD TOMORROW.
          </p>
        }
      />
      <div ref={lucky.ref} className="pf-lucky-stage" data-testid="portfolio-unlock-stage">
        <PortfolioRainbow celebrating={lucky.celebrating} count={lucky.count} />
        {lucky.celebrating && <div className="pf-lucky-message" role="status" data-testid="portfolio-unlock-message">★ THE FUTURE IS UNLOCKED ★</div>}
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-[repeat(6,minmax(0,1fr))_1.15fr]" data-testid="portfolios-grid">
        {THEMATIC_PORTFOLIOS.map((p, i) => <ThematicPortfolioCard key={p.id} portfolio={p} index={i} celebrating={lucky.celebrating} reducedMotion={lucky.reduced} />)}
        <Reveal delay={0.3} className="flex items-center sm:col-span-2 lg:col-span-3 xl:col-span-1 xl:pl-4">
          <div className="font-display text-2xl font-black leading-[1.05] tracking-tight text-white sm:text-3xl xl:text-[1.9rem]" data-testid="portfolios-tagline">
            DIVERSIFY.<br />INNOVATE.<br />
            <span className="text-neon glow-green">GROW.</span><br />
            <span className="mt-3 block font-display text-base font-bold tracking-[0.12em] text-white/85 md:text-lg">A STRONGER</span>
            <span className="text-neon glow-green">TOMORROW.</span>
          </div>
        </Reveal>
      </div>
      </div>
      <p className="mt-10 max-w-3xl font-body text-sm font-medium text-white/45" data-testid="portfolios-disclaimer">
        KINGBULLISH Smart Portfolios and Thematic Portfolios are ecosystem products, not regulated investment funds or ETFs. Nothing on this page is financial advice. No profits or returns are promised.
      </p>
    </div>
  </section>
  );
};
